<template>
  <div class="user-con-box">
    <user-avatar :img="detail.avatarUrl" :text="detail.nickname"></user-avatar>
    <div class="user-con-content">
      <div class="text ellipsis_line2">
        {{detail.nickname}}
        <el-tag class="ml5" :type="detail.isVip?'primary':'info'">{{ detail.isVip === 0 ? "普通" : `VIP${detail.isVip}` }}</el-tag>
      </div>
      <div class="id">
        ID:{{detail.userCode || detail.code}}
      </div>
    </div>
  </div>
</template>

<script>

import UserAvatar from "@/components/base/user-avatar.vue";

export default {
  props:{
    detail:{
      type:Object,
      required:true
    }
  },
  name: "user-box",
  components: {UserAvatar},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.user-con-box{
  display: flex;
  align-items: center;
  .user-con-content{
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .id{
      display: flex;
      align-items: center;
      color: #9e9e9e;
      line-height: 18px;
    }
    .text{
      font-weight: bold;
      line-height: 18px;
    }
  }
}
</style>
